/**
 * API DOC: https://apiv4.stagecb.sharkscode.com/api/doc/jackpots
 * */

import useUrl from './helpers/useUrl'

export default (client, { apiUrl, $formFactor }) => {
  const root = useUrl(`${apiUrl}/jackpots`)

  return {
    /**
     * @param {Object} JackpotPragmaticDataDTO
     * @param {string} [JackpotPragmaticDataDTO.version]
     *
     * @returns {Promise<AxiosResponse<JackpotPragmaticDataResponse>>}
    * */
    jackpotPragmaticData({ version }) {
      if (!version) version = $formFactor()

      const url = root('public/pragmatic')
      const params = {
        version,
      }
      return client.get(url, { params })
    },
  }
}

/** @typedef {Object} JackpotPragmaticDataResponse
 * @property {number} mainJackpotID
 * @property {string} name
 * @property {string} level
 * @property {string} status
 * @property {number|undefined} tiersNumber
 * @property {object[]} tiers
 * @property {number} tiers.jackpotTierID
 * @property {number} tiers.tier
 * @property {number} tiers.amount
 * @property {object[]} tiers.winners
 * @property {string} tiers.winners._id
 * @property {number} tiers.winners.jackpotID
 * @property {string} tiers.winners.extPlayerID
 * @property {number} tiers.winners.amountInPlayerCurrency
 * @property {string} tiers.winners.tier
 * @property {string} tiers.winners.payoutStatus
 * @property {number} tiers.winners.winDate
 * @property {string} tiers.winners.winType
 * @property {number} tiers.winners.playSessionID
 * @property {string} tiers.winners.playerCurrencySymbol
 * @property {object[]} games
 * @property {number} games.iframe
 * @property {string} games.name
 * @property {string} games.term
 * @property {string} games.provider
 * @property {string} games.icon_url
 * @property {number} games.is_new
 * @property {number} games.is_popular
 * @property {number} games.is_tournament
 * @property {number} games.id
 */
